/**
 * AutoImporting components
 * @param path
 * @returns {function(): *}
 */
const page = path => () => import(/* webpackChunkName: '' */ `./components/${path}`).then(m => m.default || m)

export const routes = [
    {
        path: '/reports',
        name: 'Reports',
        component: page('ReportList'),
    },
    {
        path: '/reports/:id',
        name: 'Show Report',
        component: page('ReportView'),
        hidden: true
    }
]
